/**
 * Generated runtime TestId mirror for frontend/src/pages/EnforcementObjects.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const EnforcementObjectsTestIds = {
  colExternalId: "col-external-id",
  colName: "col-name",
  colResource: "col-resource",
  colSystem: "col-system",
  colType: "col-type",
  enforcementObjectsList: "enforcement-objects-list",
  linkEnforcementObject: (obj_id: string) => `link-enforcement-object-${obj_id}`,
  linkEnforcementObjectPrefix: () => "link-enforcement-object-" as TestIdPrefix,
  linkResource: (obj_resource_id: string) => `link-resource-${obj_resource_id}`,
  linkResourcePrefix: () => "link-resource-" as TestIdPrefix,
  linkSystem: (obj_targetSystem_id: string) => `link-system-${obj_targetSystem_id}`,
  linkSystemPrefix: () => "link-system-" as TestIdPrefix
} as const;
